import { Badge } from "@/components/ui/badge";
import { type XeroRunStatus, type XeroTriggerStatus } from "@/services/xeroApi";


const STATUS_STYLES: Record<XeroRunStatus, string> = {
  succeeded: "border-emerald-200 bg-emerald-50 text-emerald-700",
  failed: "border-red-200 bg-red-50 text-red-700",
  skipped: "border-border bg-muted text-muted-foreground",
  started: "border-amber-200 bg-amber-50 text-amber-700",
};


export function StatusBadge({ status }: { status: XeroRunStatus | null }) {
  if (!status) {
    return <span className="text-muted-foreground">Never run</span>;
  }
  return (
    <Badge variant="outline" className={`font-normal ${STATUS_STYLES[status]}`}>
      {status}
    </Badge>
  );
}


const TRIGGER_STYLES: Record<XeroTriggerStatus, string> = {
  waiting: "border-violet-200 bg-violet-50 text-violet-700",
  queued: "border-amber-200 bg-amber-50 text-amber-700",
  running: "border-sky-200 bg-sky-50 text-sky-700",
  completed: "border-emerald-200 bg-emerald-50 text-emerald-700",
  failed: "border-red-200 bg-red-50 text-red-700",
  cancelled: "border-border bg-muted text-muted-foreground",
  unknown: "border-border bg-muted text-muted-foreground",
};


const TRIGGER_LABELS: Partial<Record<XeroTriggerStatus, string>> = {
  waiting: "queued in Prism",
};

export function TriggerStatusBadge({ status }: { status: XeroTriggerStatus }) {
  return (
    <Badge variant="outline" className={`font-normal ${TRIGGER_STYLES[status]}`}>
      {TRIGGER_LABELS[status] ?? status}
    </Badge>
  );
}
